export class ActivityReportService {
  static $inject = ['$resource'];

  private resource: any;

  constructor($resource) {
    this.resource = $resource('/api/activityReports/:activity');
  }

  get(...args) {
    return this.resource.get(...args);
  }
}


